import React from 'react';
import './Modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faFloppyDisk } from '@fortawesome/free-solid-svg-icons';

const Modal = ({
    show,
    onClose,
    onSave,
    title,
    rightTitle,
    className,
    hideButtons = false,
    children,
    size = 'modal-dialog-centered modal-lg',
    showCloseButton = true,
    backdrop = true,
    loading = false,
    editMode = false,
    disableSave = false,
    IsForUploadPopup = false,
    outsideClick = false,
    primaryActionLabel,
    footer
}) => {
    if (!show) return null;

    const handleBackdropClick = (e) => {
        if (backdrop && e.target === e.currentTarget && outsideClick) {
            onClose();
        }
    };

    return (
        <div
            className={`${className} modal fade ${show ? 'show d-block' : 'd-none'}`}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            style={{ backgroundColor: show ? 'rgba(0,0,0,0.5)' : 'transparent' }}
            onClick={handleBackdropClick}
        >
            <div className={`modal-dialog ${size}`}>
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>

                        <div className="d-flex align-items-center">
                            {rightTitle && (
                                <h5 className="modal-title me-3 m-0 p-0">{rightTitle}</h5>
                            )}

                            {showCloseButton && (
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={onClose}
                                    aria-label="Close">
                                </button>
                            )}
                        </div>
                    </div>
                    <div className="modal-body">
                        {children}
                    </div>
                    {footer ? (
                        <div className="modal-footer p-1">{footer}</div>
                    ) : (!hideButtons && (
                        <div className="modal-footer p-1">
                            <button
                                type="submit"
                                className="btn btn-primary save-button"
                                onClick={onSave}
                                disabled={loading || disableSave}
                            >
                                <FontAwesomeIcon icon={faFloppyDisk} className='me-2' />
                                {primaryActionLabel !== undefined
                                    ? primaryActionLabel
                                    : (IsForUploadPopup
                                        ? 'Upload'
                                        : editMode
                                            ? 'Update'
                                            : 'Save')}
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary cancel-button"
                                onClick={onClose}
                            >
                                <FontAwesomeIcon icon={faCircleXmark} className='me-2' />
                                Cancel
                            </button>
                        </div>
                    ))}

                </div>
            </div>
        </div>
    );
};

export default Modal;
